import { QueryKeys } from "@/infra/query";
import { useApi, useAuth } from "@akina/infra";
import { useQuery } from "@tanstack/react-query";

const ACTIVE_TREATMENT_DATA_STALE_TIME = 1000 * 60 * 3; // 3min

export const useFetchActiveTreatment = () => {
  const { api } = useApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [QueryKeys.fetchActiveTreatment],
    queryFn: () => api.treatment.getActiveTreatment(),
    staleTime: ACTIVE_TREATMENT_DATA_STALE_TIME,
    enabled: isAuthenticated,
  });
};
